{
  "schemaVersion": 1,
  "id": "fronts-rules",
  "version": "1.0",
  "selfAuthored": true,
  "author": "David Mansaray",
  "authoredAt": "2026-10-11",
  "sources": [
    "research/taxonomy.md §1.13: doors and drawers are a modifier in a cell; the carcass does not change",
    "Common cabinet-making practice: full-overlay doors on 35 mm concealed cup hinges, 2 mm reveal; inset doors on butt hinges, 2.5 mm gap; ball-bearing side runners need 12.7 mm each side"
  ],
  "overlayRevealMm": 2,
  "insetGapMm": 2.5,
  "hinges": { "bands": [{ "upToMm": 900, "count": 2 }, { "upToMm": 1600, "count": 3 }, { "upToMm": 99999, "count": 4 }], "fromEndMm": 100, "cupBoreMm": 35, "cupFromEdgeMm": 4, "cup": "Concealed cup hinge, 35 mm bore, full overlay, soft-close, with mounting plate", "butt": "Solid brass butt hinge, 63 mm, with screws" },
  "runners": { "clearanceMm": 12.7, "lengthsMm": [250, 300, 350, 400, 450], "spec": "Ball-bearing side runner, full extension, 45 mm, pair" },
  "drawerBox": { "thicknessMm": 12, "material": "Birch plywood 12 mm (drawer boxes)", "topClearanceMm": 25, "bottomClearanceMm": 5, "minHeightMm": 60, "minInnerDepthMm": 250 },
  "glazed": { "stileMm": 60, "railMm": 60, "rebateMm": 8, "glassThicknessMm": 4, "glass": "Toughened glass 4 mm, to order, sized to the rebate less 2 mm", "minClearMm": 80 },
  "sliding": { "overlapMm": 30, "trackGapMm": 3, "track": "Surface-mounted twin sliding-door track, top and bottom, aluminium" },
  "pulls": { "knob": "Round knob, 30 mm, with machine screw", "bar": "Bar handle, 128 mm centres, with machine screws", "fromEdgeMm": 40 }
}
